/* global window:true */

const serverFetch = () => () => Promise.resolve();

const clientFetch = () => {
  // eslint-disable-next-line
  window.fetch = require('cross-fetch');
  return window.fetch;
};

// eslint-disable-next-line
const fetch = global.window && global.window.document
  ? clientFetch()
  : serverFetch();

export { fetch };
